import { useEffect } from "react"

import { documentStyles } from "utils/updateStyles"

export function useSetVerticalScroll() {
    useEffect(() => {
        documentStyles.set("overflow-y: scroll;")
        return documentStyles.clean
    }, [])
}
